export default __webpack_public_path__ + "static/media/keto_pro@3x.ba800b2a.jpg";